import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Registrants() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      const { data: webinars } = await api.get("/webinars");
      const all = [];
      for (const w of webinars) {
        const { data } = await api.get(`/webinars/${w.id}/registrants`);
        data.forEach((r) => all.push({ ...r, webinar_title: w.title, webinar_slug: w.slug }));
      }
      all.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
      setRows(all);
    })();
  }, []);

  const filtered = q.trim() ? rows.filter((r) => (r.name + r.email + r.whatsapp + r.webinar_title).toLowerCase().includes(q.toLowerCase())) : rows;

  return (
    <div className="space-y-6 vp-fade-up">
      <div>
        <div className="vp-label">Registrants</div>
        <h1 className="font-display text-3xl font-bold mt-1">All registrants</h1>
      </div>
      <div className="vp-glass p-4">
        <input placeholder="Search by name, email, phone or webinar" value={q} onChange={(e) => setQ(e.target.value)} className="vp-input" data-testid="registrants-search" />
      </div>
      <div className="vp-glass p-4 overflow-x-auto">
        <table className="vp-table min-w-[720px]">
          <thead><tr><th>Name</th><th>Email</th><th>WhatsApp</th><th>Webinar</th><th>Payment</th><th>When</th></tr></thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={6} className="text-[#747680]">No registrations yet.</td></tr>}
            {filtered.map((r) => (
              <tr key={r.id}>
                <td className="text-[#0B0D17]">{r.name}</td>
                <td>{r.email}</td>
                <td>{r.country_code}{r.whatsapp}</td>
                <td><Link to={`/app/webinars/${r.webinar_id}`} className="text-[#0B5CFF] hover:underline">{r.webinar_title}</Link></td>
                <td><span className="vp-chip">{r.payment_status}</span></td>
                <td className="text-xs text-[#747680]">{new Date(r.created_at).toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
